import React, { useRef, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationRootState } from '../../../types';
import { useTranslation } from 'react-i18next';
import useOnClickOutside from 'use-onclickoutside';
import { setColorsPanelAction } from '../../Configurator/actions/general';
import { ActivePanel } from '../../Configurator/constants/general';
import Img from '../../../components/Img';
import SlatsImg from '../../../assets/images/handles/slats.svg';
import { switchHandlesModeAction, switchModeAction } from '../actions';
import { ConfiguratorMode, HandlesMode } from '../reducer';
import { FiChevronDown } from 'react-icons/all';
import { StyledModeButton } from '../index';
import {
  selectBigShelvesShelvesAction,
  selectDoorsShelvesAction,
  selectDrawerShelvesAction,
} from '../../Configurator/actions/selection';
import {
  makeSelectShouldShowBigDoorsHandles,
  makeSelectShouldShowDoorsHandles,
  makeSelectShouldShowDrawersHandles,
} from '../selectors';
import CupImg from 'assets/images/handles/cup.svg';
import DrawerKnop from 'assets/images/handles/drawerKnop.svg';

// import styled from 'styled-components';

interface Props {
  activeMode: ConfiguratorMode;
}

interface StateProps {
  haveOneDrawer: boolean;
  shouldDisplayDoorsHandles: boolean;
  shouldDisplayBigDoorsHandles: boolean;
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  haveOneDrawer: makeSelectShouldShowDrawersHandles(),
  shouldDisplayDoorsHandles: makeSelectShouldShowDoorsHandles(),
  shouldDisplayBigDoorsHandles: makeSelectShouldShowBigDoorsHandles(),
});

const HandlesModeSelector = ({ activeMode }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    haveOneDrawer,
    shouldDisplayDoorsHandles,
    shouldDisplayBigDoorsHandles,
  } = useSelector(stateSelector);
  const [isOpen, setOpen] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    hide();
  });

  const hide = () => {
    setOpen(false);
  };

  if (
    !haveOneDrawer &&
    !shouldDisplayDoorsHandles &&
    !shouldDisplayBigDoorsHandles
  ) {
    return null;
  }

  return (
    <div className="relative text-main">
      <StyledModeButton
        onClick={() => {
          setOpen(!isOpen);
        }}
        className="px-1 py-2 hover:bg-gray-200 flex items-center"
        data-for="mode"
        data-tip={t('Handles')}
        selected={activeMode === ConfiguratorMode.handles ? 1 : 0}
      >
        {/*<FaCircle className="h-6 w-6" />*/}
        <Img src={CupImg} alt="Cup" className="h-6 w-6" />
        <FiChevronDown className="h-4  w-4" />
      </StyledModeButton>
      {isOpen && (
        <ul
          ref={ref}
          className="position left-0 top-0  ml-12  absolute bg-white border border-gray-400 w-56 z-100"
        >
          <li className="flex justify-center text-lg italic font-light border-b border-gray-200">
            {t('Handles')}
          </li>
          {shouldDisplayDoorsHandles && (
            <li className="">
              <button
                onClick={() => {
                  dispatch(selectDoorsShelvesAction());
                  dispatch(switchModeAction(ConfiguratorMode.handles));
                  dispatch(setColorsPanelAction(ActivePanel.handles));
                  setOpen(false);
                  dispatch(switchHandlesModeAction(HandlesMode.doors));
                }}
                className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
              >
                <Img src={CupImg} alt="Cup" className="h-8 w-8" />
                <div className="ml-4">{t('Doors handles')}</div>
              </button>
            </li>
          )}
          {haveOneDrawer && (
            <li className="">
              <button
                onClick={() => {
                  dispatch(selectDrawerShelvesAction());
                  dispatch(switchModeAction(ConfiguratorMode.handles));
                  dispatch(setColorsPanelAction(ActivePanel.handles));
                  setOpen(false);
                  dispatch(switchHandlesModeAction(HandlesMode.drawers));
                }}
                className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
              >
                <Img src={DrawerKnop} alt="Knop" className="h-8 w-8" />
                <div className="ml-4">{t('Drawers handles')}</div>
              </button>
            </li>
          )}
          {shouldDisplayBigDoorsHandles && (
            <li className="">
              <button
                onClick={() => {
                  dispatch(selectBigShelvesShelvesAction());
                  dispatch(switchModeAction(ConfiguratorMode.handles));
                  dispatch(setColorsPanelAction(ActivePanel.handles));
                  setOpen(false);
                  dispatch(switchHandlesModeAction(HandlesMode.bigShelves));
                }}
                className="flex items-center px-3 py-2 hover:bg-gray-200 w-full"
              >
                <Img src={SlatsImg} alt="big compartment" className="h-8 w-8" />
                <div className="ml-4">{t('Slats')}</div>
              </button>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default HandlesModeSelector;
